export default "__VITE_ASSET__oJfym6i4__"